import Part from "../../part";

export default class Bar extends Part {

  constructor(section) {
    super(section);

    this.cost = {
          'no': 0,
          'yes': 0,
        };

    this.form.on('catcalc.change.wedding', () => {
      this.updatePricing();
    })

  }

  get options() {
    return {

      'beer & wine only tier one': {
        price: {
          'no': 12,
          'yes': 18,
        },
        description: `A selection of house wines (such as Veramonte sauvignon blanc and SeaGlass pinot noir) and house beers (including many Michigan selections).`,
      },
      'beer & wine only tier two': {
        price: {
          'no': 16,
          'yes': 22,
        },
        description: `A more upscale selection of house wines (such as White Haven sauvignon blanc and Meiomi pinot noir) and house beers (including many Michigan selections and M-43 IPA from Old Nation Brewing Company)`,
      },
      'well bar with beer & wine': {
        price: {
          'no': 18,
          'yes': 28,
        },
        description: `Tier One wines, craft beers (including many Michigan selections) and an offering of classic cocktails with our house liquor pours (Tanqueray Gin, Tito’s Handmade Vodka, Espolon Tequila, Jack Daniel’s Whiskey, Crown Royal,  Bacardi Rum, Johnny Walker Red Scotch Whiskey)`,
      },
      'top shelf bar with beer & wine': {
        price: {
          'no': 22,
          'yes': 32,
        },
        description: `Tier Two wines, craft beers (including many Michigan selections), and a full selection of cocktails with our top shelf liquors (Hendrick’s Gin, Ciroc Vodka, Espolon Tequila, Gosling Black Seal Rum, Woodford Reserve, Bulleit Bourbon, Bulleit Rye, Jameson Irish Whiskey, Macallan 12 yr Scotch)`,
      },
      'bartender(s) only, supplying our own beer and wine': {
        price: {
          'no': 0,
          'yes': 0,
        },
      },
      'bartender(s) only, supplying our own beer, wine and liquor for mixed drinks': {
        price: {
          'no': 0,
          'yes': 0,
        },
      },
      'none': {
        price: {
          'no': 0,
          'yes': 0,
        },
      },
    };
  }

  total() {
    if(this.calculator.event.wedding) {
      return this.perPerson(this.cost[this.calculator.event.wedding.toLowerCase()]);
    }else {
      return this.perPerson(this.cost['no']);
    }
  }

  renderPrice(option) {
    if (this.calculator.event.wedding) {
      return option.price[this.calculator.event.wedding.toLowerCase()];
    } else {
      return option.price['no'];
    }
  }

  updatePricing() {

    this.field.each((index, field) => {

      if (field) {
        let $field = $(field);
        let $gfield = $(field).parent('li');
        let option = this.options[$field.val().toLowerCase()];

        $gfield.addClass($field.val().toLowerCase().replace(' ', '-'));

        if (option && option.description) {
          $gfield.find('label .option-pricing').html(`$${this.renderPrice(option)}`);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/beverages/bar.js